<div class="divider-horizontal lg"></div>
<ion-card>
  <ion-card-content>
    <h3>{{ 'meet_in_person.title' | translate }}</h3>
    <p>{{ 'meet_in_person.description' | translate }}</p>
    <div class="button-wrapper">
      <ion-button (click)="toggleCalendly()" color="dark" fill="clear">{{ 'meet_in_person.book_office' | translate }}</ion-button>
      <ion-button (click)="toggleCalendly()" color="dark" fill="outline">{{ 'meet_in_person.book_unit' | translate }}</ion-button>
    </div>
  </ion-card-content>
</ion-card>
<div class="divider-horizontal lg"></div>
@if (showCalendly) {
  <!-- Calendly inline widget begin -->
  <div class="calendly-inline-widget" data-url="https://calendly.com/satel-info/meet-at-satel" style="min-width:320px;height:700px;"></div>
  <!-- Calendly inline widget end -->
  <div class="divider-horizontal lg"></div>
}
